import { WizMathUtils } from "@wizeoo/akm-core-lib";

/**
 * This item wrapper will be used to avoid ever modifying the source element.
 * The children collection will always be proxied
 */
export class TreeItemWrapper<T extends any> {

  private _source: T; // l'objet source
  public get source():T {
    return this._source;
  }

  private _parent: TreeItemWrapper<T> = null; // l'objet de rattachement
  private _children: TreeItemWrapper<T>[] = null; // collection d'enfants
  public get children():TreeItemWrapper<T>[] {
    return this._children;
  }
  public set children(pChildren: TreeItemWrapper<T>[]) {
    this._children = pChildren;
  }

  public uid: string; // UID généré sur constructeur, pour identification certaine

  public code: string = ''; // le code de l'objet (son code comme "parent")
  public parentCode: string = ''; // le parentCode de l'objet (le code de son "parent")

  public level: number = 0; // position dans l'arbre
  public hasChildren: boolean = false; // flag présence d'enfants
  // public selected: boolean = false; // flag sélectionné

  // public opened: boolean = false; // noeud ouvert pour affichage des enfants


  /** l'objet, le nom du champ qui porte le code, le nom du champ qui porte le code parent */
  constructor(source: T, codeField:string, parentCodeField :string) {
    this._source = source;
    this.code = source[codeField];
    this.parentCode = source[parentCodeField];
    this.uid = WizMathUtils.createUUID();
  }

  // mise à jour de mon level (et de celui de mes enfants)
  public setRecurseLevel(parentLevel : number): void {
    this.level = parentLevel + 1;
    if(this._children) {
      // console.log('setRecurseLevel',this.code, this._children);
      this._children.forEach ((child: TreeItemWrapper<T>) => {
        child.setRecurseLevel(this.level);
      })
    }
  }

  // affectation d'un parent. Prise de sa réf.
  public setParent(pParent: TreeItemWrapper<T>) : void {
    this._parent = pParent;
  }

  /**
   * Retourne le parent du wrapper
   */
  public getParent(): TreeItemWrapper<T> {
    return this._parent;
  }

  // Ajout d'un enfant dans la collection de children
  // on va alimenter son parent
  public addChild(pChild: TreeItemWrapper<T>, index?: number): void {
    if(!this._children) {// pas encore d'enfant, création de la collection
      this._children = [];
    }

    if(!index || index >= this._children.length ) {// pas d'index ou > taille, on pose en fin
      index = this._children.length -1;
    }
    this._children.splice(index,0,pChild);

    // mise à jour de mon hasChildren
    this.hasChildren = true;
    // mise à jour du parent de l'enfant (moi)
    pChild.setParent(this);
    // mise à jour (récursive) du level de la grappe d'enfants
    pChild.setRecurseLevel(this.level);

  }

  /** suppression d'un enfant */
  public removeChild(pChild: TreeItemWrapper<T>): void {
    this._children.splice(this._children.indexOf(pChild), 1);
    if(this._children.length<=0) { // si vide, reset sur le hasChildren
      this._children = null;
      this.hasChildren = false;
    }
  }
}

